// extracted by mini-css-extract-plugin
export default {"headingText":"manageApps_headingText__TXMrc","emptyState":"manageApps_emptyState__YkDer","message":"manageApps_message__YWIke","slideTransition":"manageApps_slideTransition__bO5OL"};